ALL_EVENT_LIST_ENDPOINT